import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { infiniteQueryOptions } from '../utils';
import { MeteringModemTypeGrid } from './types';

export const meteringModemTypeApi = createApi({
  reducerPath: 'meteringModemTypeApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/modem-types`,
  }),
  tagTypes: ['ModemTypes', 'ModemType'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringModemTypeI: builder.infiniteQuery<
      MeteringModemTypeGrid[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/query`,
        params: { ...queryArg, ...pageParam },
      }),
    }),
    getMeteringModemTypeById: builder.query<MeteringModemTypeGrid, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: ['ModemType'],
    }),
  }),
});

export const { useGetMeteringModemTypeByIdQuery } = meteringModemTypeApi;

export const useGetMeteringModemTypesInfiniteQuery = normalizeInfiniteQueryData(
  meteringModemTypeApi.useGetMeteringModemTypeIInfiniteQuery,
);
